import React from 'react';

export function ContactTodosCard({
  todos = [],
  loading = false,
  error = '',
  newTitle,
  setNewTitle,
  newDesc,
  setNewDesc,
  newDue,
  setNewDue,
  onAdd,
  onToggle,
  /* onDelete, */
}) {
  return (
    <div className="card">
      <div className="card-header d-flex align-items-center justify-content-between">
        <h5 className="mb-0">Todos</h5>
      </div>
      <div className="card-body">
        <div className="mb-3">
          <label className="form-label mb-1">New Todo</label>
          <input
            className="form-control mb-2"
            placeholder="Title"
            value={newTitle}
            onChange={(e)=> setNewTitle(e.target.value)}
          />
          <textarea
            className="form-control mb-2"
            placeholder="Description (optional)"
            rows={2}
            value={newDesc}
            onChange={(e)=> setNewDesc(e.target.value)}
          />
          <div className="d-flex gap-2 align-items-end">
            <div>
              <label className="form-label mb-1">Due date</label>
              <input type="date" className="form-control" value={newDue} onChange={(e)=> setNewDue(e.target.value)} />
            </div>
            <button className="btn btn-primary ms-auto" onClick={onAdd} disabled={!newTitle.trim()}>Add</button>
          </div>
        </div>

        {loading && <div className="text-muted">Loading...</div>}
        {error && <div className="text-danger">{error}</div>}
        {!loading && todos.length === 0 && <div className="text-muted">No todos yet.</div>}

        {todos.length > 0 && (
          <div className="table-responsive">
            <table className="table table-sm align-middle">
              <thead>
                <tr>
                  <th style={{width:'36px'}}></th>
                  <th>Title</th>
                  <th>Description</th>
                  <th>Due</th>
                  {/* <th className="text-end" style={{width:'100px'}}>Actions</th> */}
                </tr>
              </thead>
              <tbody>
                {todos.map(t => (
                  <tr key={t._id} className={t.isDone ? 'table-light' : ''}>
                    <td>
                      <input type="checkbox" className="form-check-input" checked={!!t.isDone} onChange={()=> onToggle(t)} />
                    </td>
                    <td>{t.title}</td>
                    <td className="text-muted small">{t.description || '-'}</td>
                    <td>{t.dueDate ? new Date(t.dueDate).toLocaleDateString() : '-'}</td>
                    {/* <td className="text-end">
                      <button className="btn btn-sm btn-outline-danger" onClick={()=> onDelete(t)}>Delete</button>
                    </td> */}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

